import { Component, inject } from '@angular/core';

import { Store } from '@ngxs/store';

import { LoginWithRedirect } from '../../shared/state/app.actions';

@Component({
  selector: 'sh-auth-signup-page',
  template: ``,
  standalone: false
})
export class SignUpPageComponent {
  readonly #store = inject(Store);

  constructor() {
    this.#store.dispatch(
      new LoginWithRedirect({
        authorizationParams: {
          screen_hint: 'signup'
        }
      })
    );
  }
}
